class UserPolicies {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  update(userId, policies, source) {
    return this.apiClient.put(`v1/users/${userId}/policies`, {
      policies: {
        ...policies.getCreatePayload()
      },
      source
    }).then(response => response.data);
  }
}

export { UserPolicies };
//# sourceMappingURL=UserPolicies.js.map
